module.exports = __webpack_public_path__ + "media/images/scoreBet__detailScore__markCorrect-71abac099b757ee9212e5d94c74a827e.png";